export default __webpack_public_path__ + "static/media/Torpedo-3.fbb49cc5.png";